import stylesToken from "../../components/LearnMore/LearnMore.module.scss";
import styles from "./Presale.module.scss";
import { PUBLIC_ICON, PUBLIC_IMAGE } from "../../constants";
import poolsStore from "../../stores/poolsStore";
import { useNavigate } from "react-router";
import presaleStore from "../../stores/presaleStore";
import { CurrencyMap, TimerResponse } from "../../types/types";
import { observer } from "mobx-react-lite";
import { ACCOUNT_ROUTE, PRESALE_EXCHANGE_ROUTE } from "../../utils/consts";
import { Helmet } from "react-helmet";
import { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../..";
import MySpinner from "../../components/UI/MySpinner/MySpinner";
import PresaleRecentExcganges from "../../components/PresaleRecentExcganges/PresaleRecentExcganges";
import recentExchangesStore from "../../stores/recentExchagesStore";
import OurPartnersRuningLine from "../../components/OurPartnersRuningLine/OurPartnersRuningLine";

const Presale = () => {
  const navigate = useNavigate();
  const { user } = useContext(Context);

  const formRef = useRef<HTMLDivElement>(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    presaleStore.getCryptoList();
  }, []);

  const currencies = presaleStore.cryptoList;

  const [selectedCurrency, setSelectedCurrency] =
    useState<keyof CurrencyMap>("USDT (ERC20)");
  const [isOpen, setIsOpen] = useState(false);
  const [amount, setAmount] = useState<string>("");
  const [alfa, setAlfa] = useState<string>("");
  const [timer, setTimer] = useState<TimerResponse | null>(null);
  const [isAgree, setIsAgree] = useState(false);
  const [loadingAmount, setLoadingAmount] = useState(false);
  const [loadingAlfa, setLoadingAlfa] = useState(false);
  const TOTAL = 10000000;
  const PRESALE_PROGRESS_START_PERCENT = 73;
  const PRESALE_PROGRESS_TARGET_PERCENT = 100;
  const PRESALE_PROGRESS_START_REMAINING_SECONDS =
    18 * 86400 + 2 * 3600 + 36 * 60 + 42;
  const MAX_WIDTH = 260;

  let lastRequestId = 0;

  const amountTimer = useRef<NodeJS.Timeout | null>(null);
  const alfaTimer = useRef<NodeJS.Timeout | null>(null);

  const handleSelect = async (symbol: keyof CurrencyMap) => {
    await setAmount("");
    await setAlfa("");
    setSelectedCurrency(symbol);
    setIsOpen(false);
  };

  presaleStore.selectedCrypto = currencies
    ? {
      name: currencies[selectedCurrency],
      value: amount,
    }
    : null;

  presaleStore.selectedAlfa = currencies
    ? {
      name: currencies[selectedCurrency],
      value: alfa,
    }
    : null;

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = normalizeNumber(e.target.value);
    setAmount(value);

    if (value === "") {
      setAlfa("");
      if (amountTimer.current) clearTimeout(amountTimer.current);
      return;
    }

    if (amountTimer.current) clearTimeout(amountTimer.current);

    amountTimer.current = setTimeout(async () => {
      const requestId = ++lastRequestId;
      setLoadingAmount(true);

      try {
        presaleStore.setCryptoValue(value);
        await presaleStore.getCourseAlfa();

        if (requestId === lastRequestId && value !== "") {
          setAlfa(presaleStore.alfaValue);
        }
      } finally {
        setLoadingAmount(false);
      }
    }, 300);
  };

  const handleAlfaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = normalizeNumber(e.target.value);
    setAlfa(value);

    if (value === "") {
      setAmount("");
      if (alfaTimer.current) clearTimeout(alfaTimer.current);
      return;
    }

    if (alfaTimer.current) clearTimeout(alfaTimer.current);

    alfaTimer.current = setTimeout(async () => {
      const requestId = ++lastRequestId;
      setLoadingAlfa(true);

      try {
        presaleStore.setAlfaValue(value);
        await presaleStore.getCourseCrypto();

        if (requestId === lastRequestId && value !== "") {
          setAmount(presaleStore.cryptoValue);
        }
      } finally {
        setLoadingAlfa(false);
      }
    }, 300);
  };

  useEffect(() => {
    const fetchTimer = async () => {
      try {
        const response = await fetch(
          "/api/v1/timers/current",
          { method: "GET" }
        );
        const data: TimerResponse = await response.json();
        setTimer(data);
      } catch (error) {
        console.error("Ошибка при выполнении fetch-запроса timer:", error);
      }
    };

    fetchTimer();

    const interval = setInterval(fetchTimer, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClickBuy = async () => {
    if (!presaleStore.alfaValue && !presaleStore.cryptoValue) {
      alert("Please enter valid amounts for ALFA and Crypto.");
    } else if (
      !Number(timer?.days) &&
      !Number(timer?.hours) &&
      !Number(timer?.minutes)
    ) {
      alert("The timer has expired. Please try again later.");
    } else if (!isAgree) {
      alert("Please agree to the terms and conditions.");
    } else {
      presaleStore.setResult(
        currencies[selectedCurrency],
        parseFloat(amount),
        parseFloat(alfa)
      );
      if (user.isAuth) {
        await presaleStore.setClickBuy(true);
        navigate(PRESALE_EXCHANGE_ROUTE);
        await user.setIsLoading(true);
        await presaleStore.sendDataPresale();
        await user.setIsLoading(false);
      } else {
        presaleStore.setClickBuy(true);
        navigate(ACCOUNT_ROUTE);
      }
    }
  };

  const handleChange = () => {
    setIsAgree((prev) => !prev);
  };

  const removeLeadingZero = (value: string | number | undefined): string => {
    let letValue = String(parseInt(String(value), 10));
    if (letValue === "NaN") {
      return "";
    }
    return String(parseInt(String(value), 10));
  };

  const normalizeNumber = (value: string) => {
    if (!value) return "";
    return value.replace(",", ".");
  };

  const sumExchanges = (value: number) => {
    const def = 0;
    const sumOfExchanges = value + def;
    return sumOfExchanges;
  };

  const currentTimerRemainingSeconds =
    Number(timer?.days || 0) * 86400 +
    Number(timer?.hours || 0) * 3600 +
    Number(timer?.minutes || 0) * 60 +
    Number(timer?.seconds || 0);
  const progressElapsedRatio = PRESALE_PROGRESS_START_REMAINING_SECONDS
    ? 1 -
    currentTimerRemainingSeconds / PRESALE_PROGRESS_START_REMAINING_SECONDS
    : 0;
  const currentRaisedPercent = Math.min(
    PRESALE_PROGRESS_TARGET_PERCENT,
    Math.max(
      PRESALE_PROGRESS_START_PERCENT,
      PRESALE_PROGRESS_START_PERCENT +
      (PRESALE_PROGRESS_TARGET_PERCENT - PRESALE_PROGRESS_START_PERCENT) *
      progressElapsedRatio
    )
  );
  const currentRaisedUsd = (TOTAL * currentRaisedPercent) / 100;

  return (
    <>
      <Helmet>
        <title>Presale</title>
        <link rel="icon" href={PUBLIC_ICON + "Alfa.svg"} />
      </Helmet>
      <div className={styles.presale__wrapper} ref={formRef}>
        <div className={styles.presale__Exchanger}>
          <div className={styles.presale__Exchanger__topLines}>
            <img src={PUBLIC_IMAGE + "presale__Exchanger__topLines.svg"} />
          </div>
          <div className={styles.presale__Exchanger__topLinesMob}>
            <img src={PUBLIC_IMAGE + "presale__Exchanger__topLinesMob.svg"} />
          </div>
          <div className={styles.presale__Exchanger__content}>
            <div className={styles.presale__Exchanger__title_text}>
              <img src={PUBLIC_IMAGE + "presaleTitle1.svg"} />
            </div>
            <div className={styles.presale__Exchanger__title}>3 ROUND</div>
            <div className={styles.presale__Exchanger__progressLine}>
              <div className={styles.presale__Exchanger__progressLineTitle}>
                <div
                  className={styles.presale__Exchanger__progressLineTitleLeft}
                >
                  1 ALFA = $1.5
                </div>
                <div
                  className={styles.presale__Exchanger__progressLineTitleright}
                >
                  NEXT price 1 ALFA = $10
                </div>
                <div
                  className={styles.presale__Exchanger__progressLineTitleright}
                ></div>
              </div>
              <div className={styles.presale__Exchanger__progressLineStats}>
                <div className={styles.presale__Exchanger__progressLineStatsPurchased}>
                  {currentRaisedUsd.toLocaleString("en-US", {maximumFractionDigits: 0})}
                  $
                </div>
                <div className={styles.presale__Exchanger__progressLineStatsSeparator}>
                  ·
                </div>
                <div className={styles.presale__Exchanger__progressLineStatsProcent}>
                  {currentRaisedPercent.toFixed(2)}
                  %
                </div>
              </div>
              <div className={styles.presale__Exchanger__progressLineBody}>
                <div
                  className={styles.presale__Exchanger__progressLineFill}
                  style={{
                    width: `${currentRaisedPercent}%`,
                  }}
                >
                </div>
                <div
                  className={styles.presale__Exchanger__progressLineToFill}
                ></div>
                <div
                  className={
                    styles.presale__Exchanger__progressLineToFillNextRound
                  }
                >
                  <div
                    className={
                      styles.presale__Exchanger__progressLineToFillNextRoundText
                    }
                  >
                    4 ROUND
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.presale__Exchanger__timer}>
              <div className={styles.presale__Exchanger__timerItem}>
                <div className={styles.presale__Exchanger__timerImg}>
                  <div
                    className={
                      timer
                        ? styles.presale__Exchanger__timerTextDays
                        : styles.presale__Exchanger__timerSpinner
                    }
                  >
                    {timer ? timer.days : <MySpinner />}
                  </div>{" "}
                </div>
                {/* Display hours from timer */}
              </div>
              <div className={styles.presale__Exchanger__timerPoint}>:</div>
              <div className={styles.presale__Exchanger__timerItem}>
                <div className={styles.presale__Exchanger__timerImg}>
                  <div
                    className={
                      timer
                        ? styles.presale__Exchanger__timerTextMinutes
                        : styles.presale__Exchanger__timerSpinner
                    }
                  >
                    {timer ? timer?.hours : <MySpinner />}
                  </div>
                </div>
              </div>
              <div className={styles.presale__Exchanger__timerPoint}>:</div>
              <div className={styles.presale__Exchanger__timerItem}>
                <div className={styles.presale__Exchanger__timerImg}>
                  <div
                    className={
                      timer
                        ? styles.presale__Exchanger__timerText
                        : styles.presale__Exchanger__timerSpinner
                    }
                  >
                    {timer ? timer?.minutes : <MySpinner />}
                  </div>
                </div>
              </div>
              <div className={styles.presale__Exchanger__timerPoint}>:</div>
              <div className={styles.presale__Exchanger__timerItem}>
                <div className={styles.presale__Exchanger__timerImg}>
                  <div
                    className={
                      timer
                        ? styles.presale__Exchanger__timerText
                        : styles.presale__Exchanger__timerSpinner
                    }
                  >
                    {timer ? timer?.seconds : <MySpinner />}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.presale__Exchanger__form}>
              <div className={styles.presale__Exchanger__formHeader}>
                <div className={styles.presale__Exchanger__formHeaderTitle}>
                  1 ALFA = $1.5
                </div>
              </div>
              <div className={styles.presale__Exchanger__formBody}>
                <div className={styles.presale__Exchanger__formBodyAlfa}>
                  <div
                    className={styles.presale__Exchanger__formBodyAlfaWrapper}
                  >
                    <div
                      className={
                        styles.presale__Exchanger__formBodyAlfaWrapperImg
                      }
                    >
                      <img src={PUBLIC_ICON + "Alfa.svg"} alt="" />
                    </div>
                    <div
                      className={
                        styles.presale__Exchanger__formBodyAlfaWrapperTitle
                      }
                    >
                      ALFA
                    </div>
                  </div>
                  <div
                    className={
                      styles.presale__Exchanger__formBodyAlfaWrapperLine
                    }
                  ></div>
                  <div className={styles.InputspinnerWrapper}>
                    {loadingAmount ? (
                      <div style={{ marginLeft: "20px" }}>
                        <MySpinner></MySpinner>
                      </div>
                    ) : (
                      <input
                        className={
                          styles.presale__Exchanger__formBodyAlfaWrapperInput
                        }
                        placeholder="0"
                        value={alfa}
                        onChange={handleAlfaChange}
                      ></input>
                    )}
                  </div>
                </div>
                {currencies && (
                  <div className={styles.presale__Exchanger__formBodyCrypto}>
                    <div
                      className={
                        styles.presale__Exchanger__formBodyCryptoSelect
                      }
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <div
                        className={
                          styles.presale__Exchanger__formBodyAlfaWrapperImg
                        }
                      >
                        <img
                          src={`${PUBLIC_ICON}${selectedCurrency.toLowerCase().split(" ")[0]
                            }.svg`}
                          alt={currencies[selectedCurrency]}
                        />
                      </div>
                      <div
                        className={
                          ["USDT (ERC20)", "USDT (TRC20)"].includes(
                            selectedCurrency
                          )
                            ? styles.presale__Exchanger__formBodyAlfaWrapperTitleUSDT
                            : styles.presale__Exchanger__formBodyAlfaWrapperTitle
                        }
                      >
                        {["USDT (ERC20)", "USDT (TRC20)"].includes(
                          selectedCurrency
                        ) ? (
                          <>
                            {selectedCurrency.split(" ")[0]}
                            {""}
                            <span
                              className={
                                styles.presale__Exchanger__formBodyAlfaWrapperTitleSmall
                              }
                            >
                              ({selectedCurrency.match(/\((.*?)\)/)?.[1]})
                            </span>
                          </>
                        ) : (
                          selectedCurrency.split(" ")[0]
                        )}
                      </div>
                      <img
                        className={
                          styles.presale__Exchanger__formBodyCryptoArrow
                        }
                        src={PUBLIC_IMAGE + "arrowRight.svg"}
                        alt=""
                      />
                    </div>

                    {isOpen && (
                      <div className={styles.dropdown}>
                        {(
                          Object.entries(currencies) as [
                            keyof CurrencyMap,
                            string
                          ][]
                        ).map(([symbol, name]) => (
                          <div
                            key={symbol}
                            className={styles.dropdownItem}
                            onClick={() => handleSelect(symbol)}
                          >
                            <img
                              src={`${PUBLIC_ICON}${symbol.toLowerCase().split(" ")[0]
                                }.svg`}
                              alt={name}
                              width={20}
                            />
                            <span>{symbol}</span>
                          </div>
                        ))}
                      </div>
                    )}

                    <div
                      className={
                        styles.presale__Exchanger__formBodyAlfaWrapperLine
                      }
                    ></div>

                    <div
                      className={
                        styles.presale__Exchanger__formBodyCryptoWrapperInput
                      }
                    >
                      {loadingAlfa ? (
                        <div style={{ marginLeft: "20px" }}>
                          <MySpinner></MySpinner>
                        </div>
                      ) : (
                        <input
                          className={
                            styles.presale__Exchanger__formBodyCryptoInput
                          }
                          placeholder="0"
                          onChange={handleAmountChange}
                          value={amount}
                        />
                      )}
                    </div>
                  </div>
                )}
                <div className={styles.remember__data}>
                  <input
                    type="checkbox"
                    className={styles.form__checkbox}
                    id="checkbox1"
                    name="rememberData"
                    onChange={handleChange}
                    checked={isAgree}
                  />
                  <div className={styles.form__checkboxText}>
                    By purchasing, you agree to the
                    <a
                      className={styles.form__checkboxTextLink}
                      onClick={() =>
                        window.open(
                          "/api/v1/docs/token-sale-terms",
                          "_blank"
                        )
                      }
                    >
                      {" "}
                      Token Sale Terms,
                    </a>
                    <a
                      className={styles.form__checkboxTextLink}
                      onClick={() =>
                        window.open(
                          "/api/v1/docs/tokenomics-investor-overview"
                        )
                      }
                    >
                      {" "}
                      Tokenomics & Investor Overview
                    </a>
                  </div>
                </div>
                <button
                  className={styles.presale__Exchanger__formBodyCryptoButton}
                  onClick={handleClickBuy}
                >
                  {" "}
                  <div className={styles.myBtn__wrapper}>
                    <div className={styles.buttonImg}>
                      <div className={styles.leftImg}>
                        <img
                          src={PUBLIC_IMAGE + "button-leftImage.svg"}
                          alt="triangle"
                        />
                      </div>
                      <div className={styles.rightImg}>
                        <img
                          src={PUBLIC_IMAGE + "button-rightImage.svg"}
                          alt="lightning"
                        />
                      </div>
                      <div className={styles.myBtn__text}>BUY</div>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className={styles.presale__Exchanger__leftImg}>
            <img
              src={PUBLIC_IMAGE + "presale__Exchanger__leftImg.webp"}
              alt=""
            />
          </div>
          <div className={styles.presale__Exchanger__rightImg}>
            <img
              src={PUBLIC_IMAGE + "presale__Exchanger__rightImg.webp"}
              alt=""
            />
          </div>
          <div className={styles.presale__Exchanger__bottomLines}>
            <img src={PUBLIC_IMAGE + "presale__Exchanger__bottomLines.svg"} />
          </div>
          <div className={styles.presale__Exchanger__bottomLinesMob}>
            <img
              src={PUBLIC_IMAGE + "presale__Exchanger__bottomLinesMob.svg"}
            />
          </div>
          <div className={styles.presale__warningText}>
            The presale phase may close earlier once the planned funding amount
            is reached or adjusted by the team.We recommend completing your
            purchase in advance, as availability may be limited.
          </div>
          <div className={styles.presale__ourPartners}>
            <OurPartnersRuningLine></OurPartnersRuningLine>
          </div>
        </div>
        <div className={styles.presale__recentExcgangesWrapper}>
          <PresaleRecentExcganges></PresaleRecentExcganges>
        </div>
        <div
          className={`${poolsStore.isSubscribe
            ? stylesToken.LearnMoreNone
            : styles.JoinTheFuture
            }`}
        >
          <div className={styles.LearnMore__borderTopPresale}></div>
          <div className={stylesToken.LearnMore__content}>
            <div className={styles.LearnMore__image}>
              <img src={PUBLIC_IMAGE + "3DAlfaCoin.webp"} alt="" />
            </div>
            <div className={stylesToken.LearnMore__line}>
              <div
                className={`${stylesToken.information__lineBox} ${stylesToken.info__boxLeft}`}
              ></div>
              <div
                className={`${stylesToken.information__lineBox} ${stylesToken.info__boxRight}`}
              ></div>
              <div className={stylesToken.information__lightBox}></div>
              <div className={stylesToken.main__informationLogo}>
                <img src={PUBLIC_IMAGE + "Main-logoImage.svg"} alt="" />
              </div>
            </div>
            <div className={stylesToken.LearnMore__page}>
              <div
                className={`${stylesToken.LearnMore__title} ${stylesToken.LearnMore__titlePresale}`}
              >
                Token “ALFA” — Not Empty Promises, but Real Assets and Genuine
                Growth.
              </div>
              <div className={stylesToken.LearnMore__text}>
                <div className={stylesToken.LearnMore__textBody}>
                  A unique opportunity to invest in a real ecosystem of projects
                  and assets through the “ALFA” token.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.presale__cryptoPlatform}>
          <div className={styles.presale__cryptoPlatformTextWrapper}>
            <div className={styles.presale__cryptoPlatformTitle}>
              Our crypto platform is launching the presale of the ASA “ALFA”
              token on the network: Algorand MainNet Token Type: ASA.
            </div>
            <div className={styles.presale__cryptoPlatformTextBody}>
              “ALFA” is not just another digital asset. It represents the real
              value of our existing and expanding platform directions, supported
              by real-world assets.
            </div>
          </div>
          <div className={styles.presale__cryptoPlatformImageWrapper}>
            <img src={PUBLIC_IMAGE + "3DCryptoPlatform.webp"} alt="" />
          </div>
        </div>
        <div className={styles.presale__AlfaToken}>
          <div className={styles.presale__AlfaTokenTitle}>
            What Makes the “ALFA” Token Unique:
          </div>
          <div className={styles.presale__AlfaTokenBackgroundImg}>
            {" "}
            <img src={PUBLIC_IMAGE + "AlfaTokenBackgroundImg.svg"} alt="" />
            <div className={styles.AlfaToken__lightBox}></div>{" "}
          </div>
          <div className={styles.presale__AlfaTokenBody}>
            <div className={styles.presale__AlfaTokenBodyBlock1}>
              <div className={styles.presale__AlfaTokenBodyBlock1Img}>
                <img
                  src={PUBLIC_IMAGE + "AlfaTokenBodyBlock1Img.webp"}
                  alt=""
                />
              </div>
              <div className={styles.presale__AlfaTokenBodyBlock1Title}>
                Real Asset Backing:
              </div>
              <div className={styles.presale__AlfaTokenBodyBlock1Text}>
                “ALFA” is backed by operational services, tangible assets, and
                new business directions that are actively developing.
              </div>
            </div>
            <div className={styles.presale__AlfaTokenBodyBlock2}>
              <div className={styles.presale__AlfaTokenBodyBlock2Img}>
                <img
                  src={PUBLIC_IMAGE + "AlfaTokenBodyBlock2Img.webp"}
                  alt=""
                />
              </div>
              <div className={styles.presale__AlfaTokenBodyBlock2Header}>
                <div className={styles.presale__AlfaTokenBodyBlock2Title}>
                  Growth and Expansion:
                </div>
              </div>
              <div className={styles.presale__AlfaTokenBodyBlock2Footer}>
                <div className={styles.presale__AlfaTokenBodyBlock1Text}>
                  Funds raised during the presale will be used to scale our
                  current services and launch new projects, further
                  strengthening the token's foundation.
                </div>
              </div>
            </div>
            <div className={styles.presale__AlfaTokenBodyBlock3}>
              <div className={styles.presale__AlfaTokenBodyBlock3Img}>
                <img
                  src={PUBLIC_IMAGE + "AlfaTokenBodyBlock3Img.webp"}
                  alt=""
                />
              </div>
              <div className={styles.presale__AlfaTokenBodyBlock1Title}>
                Technological Advantage:
              </div>
              <div className={styles.presale__AlfaTokenBodyBlock1Text}>
                “ALFA” is issued as an ASA token on the Algorand network,
                ensuring security, transparency, and high-speed transactions.
              </div>
            </div>
          </div>
        </div>
        <div className={styles.presale__Matters}>
          <div className={styles.presale__MattersImage}>
            <img src={PUBLIC_IMAGE + "3DMattersImg.webp"} alt="" />
          </div>
          <div className={styles.presale__MattersBody}>
            <div className={styles.presale__MattersTitle}>Why It Matters:</div>
            <div className={styles.presale__MattersText}>
              “ALFA” is a token tied to real economic activity, not speculative
              hype. You invest in a platform with real assets, a sustainable
              business model, and a long-term growth strategy.
            </div>
          </div>
        </div>
        <div className={styles.presale__KeyTerms}>
          <div className={styles.presale__KeyTermLightBox}></div>
          <div className={styles.presale__KeyTermsTitle}>
            {" "}
            Presale Key Terms:{" "}
          </div>

          <div className={styles.presale__KeyTermsBody}>
            <div className={styles.presale__KeyTermsItem}>
              <div className={styles.presale__KeyTermsItemImg}>
                <img
                  src={PUBLIC_IMAGE + "presale__KeyTermsItemImg1.svg"}
                  alt=""
                />
              </div>
              <div className={styles.presale__KeyTermsItemText}>
                {" "}
                Network: Algorand MainNet Token Type: ASA
              </div>
            </div>
            <div className={styles.presale__KeyTermsItem}>
              <div className={styles.presale__KeyTermsItemImg}>
                <img
                  src={PUBLIC_IMAGE + "presale__KeyTermsItemImg2.svg"}
                  alt=""
                />
              </div>
              <div className={styles.presale__KeyTermsItemText}>
                Token Type: ASA
              </div>
            </div>
            <div className={styles.presale__KeyTermsItem}>
              <div className={styles.presale__KeyTermsItemImg}>
                <img
                  src={PUBLIC_IMAGE + "presale__KeyTermsItemImg3.svg"}
                  alt=""
                />
              </div>
              <div className={styles.presale__KeyTermsItemText}>
                Backing: Existing and expanding platform directions
              </div>
            </div>
            <div className={styles.presale__KeyTermsItem}>
              <div className={styles.presale__KeyTermsItemImg}>
                <img
                  src={PUBLIC_IMAGE + "presale__KeyTermsItemImg4.svg"}
                  alt=""
                />
              </div>
              <div className={styles.presale__KeyTermsItemText}>
                {" "}
                Initial Token Price: $0.05
              </div>
            </div>
            <div className={styles.presale__KeyTermsItem}>
              <div className={styles.presale__KeyTermsItemImg}>
                <img
                  src={PUBLIC_IMAGE + "presale__KeyTermsItemImg5.svg"}
                  alt=""
                />
              </div>
              <div className={styles.presale__KeyTermsItemText}>
                {" "}
                Presale Supply: Limited number of tokens
              </div>
            </div>
          </div>
        </div>
        <div className={styles.presale__Participate}>
          <div className={styles.presale__Participate__title}>
            Why Participate:
          </div>
          <div className={styles.presale__Participate__body}>
            <div className={styles.presale__Participate__body__leftWrapper}>
              {" "}
              <div className={styles.presale__Participate__body__left1}>
                <div className={styles.presale__Participate__body__left1Text}>
                  Direct Involvement in Platform Growth: By investing in “ALFA”,
                  you become part of a growing real-world ecosystem.
                </div>
                <div className={styles.presale__Participate__body__left1Img}>
                  <img
                    src={
                      PUBLIC_IMAGE + "presale__Participate__body__left1Img.webp"
                    }
                  />
                </div>
              </div>
              <div className={styles.presale__Participate__body__left2}>
                <div className={styles.presale__Participate__body__left2Text}>
                  Cutting-Edge Technology: Algorand provides speed, reliability,
                  and cost efficiency.
                </div>
                <div className={styles.presale__Participate__body__left2Img}>
                  <img
                    src={
                      PUBLIC_IMAGE + "presale__Participate__body__left2Img.webp"
                    }
                  />
                </div>
              </div>
            </div>
            <div className={styles.presale__Participate__body__rightWrapper}>
              {" "}
              <div className={styles.presale__Participate__body__right1}>
                <div className={styles.presale__Participate__body__right1Img}>
                  <img
                    src={
                      PUBLIC_IMAGE +
                      "presale__Participate__body__right1Img.webp"
                    }
                  />
                </div>
                <div className={styles.presale__Participate__body__right1Text}>
                  Solid Foundation: The token is backed by real assets and
                  operational business processes, not abstract ideas.
                </div>
              </div>
              <div className={styles.presale__Participate__body__right2}>
                <div className={styles.presale__Participate__body__right2Img}>
                  <img
                    src={
                      PUBLIC_IMAGE +
                      "presale__Participate__body__right2Img.webp"
                    }
                  />
                </div>
                <div className={styles.presale__Participate__body__right2Text}>
                  Long-Term Vision: We are building a platform focused on
                  sustainable development rather than short-term speculation.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${poolsStore.isSubscribe
            ? stylesToken.LearnMoreNone
            : styles.JoinTheFuture
            }`}
        >
          <div className={styles.LearnMore__borderTopPresale}></div>
          <div className={stylesToken.LearnMore__content}>
            <div className={styles.LearnMore__image}>
              <img src={PUBLIC_IMAGE + "3DJoinFuture.webp"} alt="" />
            </div>
            <div className={stylesToken.LearnMore__line}>
              <div
                className={`${stylesToken.information__lineBox} ${stylesToken.info__boxLeft}`}
              ></div>
              <div
                className={`${stylesToken.information__lineBox} ${stylesToken.info__boxRight}`}
              ></div>
              <div className={stylesToken.information__lightBox}></div>
              <div className={stylesToken.main__informationLogo}>
                <img src={PUBLIC_IMAGE + "Main-logoImage.svg"} alt="" />
              </div>
            </div>
            <div className={stylesToken.LearnMore__page}>
              <div
                className={`${stylesToken.LearnMore__title} ${stylesToken.LearnMore__titlePresale}`}
              >
                Join the future of real digital economy with “ALFA”.
              </div>
              <div className={stylesToken.LearnMore__text}>
                <div className={stylesToken.LearnMore__textBody}>
                  Invest in a token backed by real assets and dedicated to
                  supporting growth across new directions.
                </div>
              </div>
              <button
                className={styles.JoinTheFuture__button}
                onClick={scrollToForm}
              >
                {" "}
                <div className={styles.myBtn__wrapper}>
                  <div className={styles.buttonImg}>
                    <div className={styles.leftImg}>
                      <img
                        src={PUBLIC_IMAGE + "button-leftImage.svg"}
                        alt="triangle"
                      />
                    </div>
                    <div className={styles.rightImg}>
                      <img
                        src={PUBLIC_IMAGE + "button-rightImage.svg"}
                        alt="lightning"
                      />
                    </div>
                    <div className={styles.myBtn__text}>BUY</div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(Presale);
